
































































































import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
// import { quillEditor } from 'vue-quill-editor'
// import 'quill/dist/quill.core.css'
// import 'quill/dist/quill.snow.css'
// import 'quill/dist/quill.bubble.css'
import * as Jodit from 'jodit/build/jodit.min.js'
import 'jodit/build/jodit.min.css'

@Component({
	components: {
		// quillEditor,
	},
})
export default class HTMLEditor extends Vue {
	@Prop() private label!: string
	@Prop() private value!: any
	private options: object = { modules: { toolbar: '#toolbar' } }
	private editor: Jodit

	@Watch('value')
	private sendContent(val: string) {
		// console.log(val)
	}

	private mounted() {
		this.editor = new Jodit('#editor')
		this.editor.value = this.value || ''
	}

	private textChange(event: any) {
		this.$emit('input', event.html)
	}

	private valueChange() {
		this.$emit('input', this.editor.value)
	}
}
